/**
 * Common used custom header names
 */
export enum EHeaderName {
  Authorization = 'Authorization',
  XCompanyId = 'X-Company-Id',
  RequestId = 'Request-Id',
  XSiteIds = 'X-Site-Ids',
  XEventId = 'x-event-id',
  XEmployeeId = 'X-Employee-Id',
  XLocales = 'X-Locales',
  XLocalesPrefix = 'X-Locales-Prefix',
}
